import { render, staticRenderFns } from "./TrainingList.vue?vue&type=template&id=59986142&"
import script from "./TrainingList.vue?vue&type=script&lang=ts&"
export * from "./TrainingList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports